import { Row } from "components/Table/OLTable";
import { useMessage } from "hooks/intl";
import { UnitTransferModal } from "types/unit-transfers";

export enum Modals {
  Activate,
  Add,
  Cancel,
  Deduct,
  Details,
  Expire,
  ImportAddingUnitsTransfers,
  ImportSpendingUnitsTransfers,
  CancelTransfers,
  ExpireTransfers,
  ActivateTransfers,
}

interface UnitTransfersModalsActionsProps {
  setOpen: (open: boolean) => void;
  setModal: (modal: UnitTransferModal) => void;
}

export function UnitTransfersModalsActions({
  setModal,
  setOpen,
}: UnitTransfersModalsActionsProps) {
  const { message } = useMessage();

  return [
    {
      action: (id?: string | React.MouseEvent<HTMLLIElement, MouseEvent>) => {
        setModal({ transfer: id as string, mode: Modals.Activate });
        setOpen(true);
      },
      hideCondition: (item: Row) =>
        item.metadata?.pending === false || item.metadata?.cancelled === true,
      label: message({ id: "activate" }),
    },
    {
      action: (id?: string | React.MouseEvent<HTMLLIElement, MouseEvent>) => {
        setModal({ transfer: id as string, mode: Modals.Cancel });
        setOpen(true);
      },
      hideCondition: (item: Row) =>
        !["adding", "blocked"].includes(item.metadata?.type) ||
        item.metadata?.cancelled === true,
      label: message({ id: "cancel" }),
    },
    {
      action: (id?: string | React.MouseEvent<HTMLLIElement, MouseEvent>) => {
        setModal({ transfer: id as string, mode: Modals.Expire });
        setOpen(true);
      },
      hideCondition: (item: Row) =>
        !["adding", "p2p_adding"].includes(item.metadata?.type) ||
        item.metadata?.cancelled === true ||
        item.metadata?.pending === true ||
        !item.metadata?.expiresAt,
      label: message({ id: "expire" }),
    },
  ];
}
